/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CreatePurchaseApplicationRequestAttachmentsInner } from './create-purchase-application-request-attachments-inner';

/**
 * 
 * @export
 * @interface CreatePurchaseApplicationRequest
 */
export interface CreatePurchaseApplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'paymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'department': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purchaseReason': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purchaseDetails': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'placeOfUse': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'purposeOfUse': CreatePurchaseApplicationRequestPurposeOfUseEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof CreatePurchaseApplicationRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'userAccountId': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'remarks': string;
    /**
     * 
     * @type {Array<CreatePurchaseApplicationRequestAttachmentsInner>}
     * @memberof CreatePurchaseApplicationRequest
     */
    'attachments': Array<CreatePurchaseApplicationRequestAttachmentsInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePurchaseApplicationRequest
     */
    'approvers': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'workRequestedBy': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePurchaseApplicationRequest
     */
    'workRequestApprovers': string | null;
}

export const CreatePurchaseApplicationRequestPurposeOfUseEnum = {
    software: 'SOFTWARE',
    fixtures: 'FIXTURES',
    conference: 'CONFERENCE',
    entertainment: 'ENTERTAINMENT',
    travel: 'TRAVEL',
    other: 'OTHER',
    initialValue: 'INITIAL_VALUE'
} as const;

export type CreatePurchaseApplicationRequestPurposeOfUseEnum = typeof CreatePurchaseApplicationRequestPurposeOfUseEnum[keyof typeof CreatePurchaseApplicationRequestPurposeOfUseEnum];


